import { Workspace, WorkspaceData, WorkspaceRole } from "@workspace/types";
import { clientFetcher } from "@workspace/api";

export const getWorkspaces = async (): Promise<WorkspaceData[]> => {
  return (await clientFetcher.get("/workspaces")).data.items;
};

export const createWorkspace = async (data: {
  name: string;
  role?: WorkspaceRole;
}): Promise<Workspace> => {
  return (await clientFetcher.post("/workspaces/new", data)).data;
};

export const renameWorkspace = async (
  id: string,
  name: string,
): Promise<void> => {
  await clientFetcher.patch(`/workspaces/${id}`, { name });
};

export const joinWorkspaceByDomain = async (): Promise<void> => {
  await clientFetcher.post("/workspaces/join-by-domain");
};
